import ReviewCardItem from './ReviewCardItem.component';

export default ReviewCardItem;
